@if (unknownLocation) {
  <div class="weather">
    <motn-spinner></motn-spinner>
    <!--  <i class="fa-regular fa-location-question"></i>-->
  </div>
} @else if (!unknownLocation && postalCode && loadingWeather) {
  <div class="weather">
    <motn-spinner></motn-spinner>
  </div>
} @else if (!unknownLocation && currentWeather && !loadingWeather) {
  <div class="weather">
    <span
      [innerHtml]="'<i class=\'fa-regular fa-'+weatherIcon+'\'>'"
    ></span>
    <span>
      {{currentWeather.TemperatureF}}&deg; / {{currentWeather.Humidity}}&percnt;
    </span>
  </div>
}
